import React, { useContext, useEffect, useState } from "react";

import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabPanel from "@mui/lab/TabPanel";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import { Grid, Typography, Box, Button } from "@mui/material";

import CarouselSlider from "../ui/coursel-slider";
// import productItem from "../../data/product-item.json";
import AuthContext from "../../store/auth/auth-context";
import { LoadingButton } from "@mui/lab";
import globalConfig from "../../config/globalConfig.json";
import { Link, NavLink } from "react-router-dom";
import Versions from "./versions";
import SupportForm from "./support-form";
// import { IFeaturesList } from "../../types/featuresList";
import FeatureRequestForm from "./feature-request-form";
import SeatsContext from "../../store/seats/seats-context";
// import FavoriteIcon from "@mui/icons-material/Favorite";
// import { url } from "inspector";
import useHttp from "../../hooks/use-http";
import InstallationGuide from "./installation-guide";

interface ProductItemPropsTypes {
  productCategoryID?: string;
  productCategoryRef?: string;
  productRef?: string;
  // productCategoryRef?: string;
}

const InnerTabs = (props: ProductItemPropsTypes) => {
  const authCxt = useContext(AuthContext);
  const seatCxt = useContext(SeatsContext);
  const { productCategoryID, productRef, productCategoryRef } = props;

  const {
    isLoading,
    isError,
    message,
    sendRequest: getProductItems,
  } = useHttp();

  // const [productItem, setProductItem] = useState<any>([]);
  const [productItemList, setproductItemList] = useState<any>([]);
  // console.log('rrrrr',productItemList)

  // const productItemList = productItem.filter(
  //   (item: any) => item.ProductCategoryID == productCategoryID
  // );

  const getProductItemsResponse = (res: any) => {
    if (res.data) {
      const filteredData = res.data.filter(
        (item: any) => item.ProductCategoryID === productCategoryID
      );
      setproductItemList(filteredData);
      // setInnerTabValue(filteredData[0]?.ReferenceName || "");
    }
  };
  // const [innerTabValue, setInnerTabValue] = useState<string | undefined>(
  //   productItemList.length > 0 ? productItemList[0]?.ReferenceName : undefined
  // );
  const [innerTabValue, setInnerTabValue] = useState<string | undefined>(undefined);


 // Add a useEffect to set a valid innerTabValue when productItemList changes
useEffect(() => {
  // console.log("productItemList", productItemList[0]?.ReferenceName);
  if (productItemList.length > 0) {
    setInnerTabValue(productItemList[0]?.ReferenceName || "");
  }
}, [productItemList,productCategoryID]);

  useEffect(() => {
    getProductItems(
      {
        URL: "/api/product/items",
        method: "GET",
        header: {
          "Content-Type": "application/json",
        },
      },
      getProductItemsResponse
    );
  }, []);

  const planLevel =
    seatCxt.plan == "Basic"
      ? 0
      : seatCxt.plan == "Standard"
      ? 1
      : seatCxt.plan == "Enterprise"
      ? 2
      : 0;

  const [formOpenState, setFormOpenState] = useState(false);
  const [versionsOpenState, setVersionOpenState] = useState(false);
  const [guideOpenState, setGuideOpenState] = useState(false);

  const [downloadType, setDownloadType] = useState("single");
  const [downloadProduct, setDownloadProduct] = useState(productRef);
  const [downloadProductCategory, setDownloadProductCategory] = useState<
    string | undefined
  >(productCategoryRef ? productCategoryRef : "");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setInnerTabValue(newValue);
  };

  const contactHandler = (data: any) => {
    setFormOpenState(true);
  };

  const versionHandler = (data: any) => {
    setVersionOpenState(true);
  };

  const guideHandler = (data: any) => {
    setGuideOpenState(true);
    // setGuideLink(data);
  };

  const [requestFormOpenState, setRequestFormOpenState] = useState(false);
  const requestFormHandler = (data: any) => {
    setRequestFormOpenState(true);
  };

  const downloadExtensionsHandler = () => {
    window.open(
      `${globalConfig.SERVER_HOST}/api/download?type=${downloadType}&product=${downloadProduct}&category=${productCategoryRef}&item=${innerTabValue}`
    );
  };

  const downloadSpecificExtensionsHandler = (version: string) => {
    // console.log(version, downloadType)
    window.open(
      `${globalConfig.SERVER_HOST}/api/download?type=${downloadType}&product=${downloadProduct}&category=${productCategoryRef}&item=${innerTabValue}&version=${version}`
    );
  };

  const openLinkHandler = (URL: string) => {
    window.open(
      `${URL}`
    );
  };


  const cleanURL = (url: string) => {
    // console.log("Original URL:", url);
    const originalUrl = url;
    const segments = originalUrl.split("/");
    // Remove duplicate consecutive segments
    const cleanedSegments = segments.filter((segment, index, arr) => {
      return segment !== arr[index - 1];
    });
    const cleanedUrl = cleanedSegments.join("/");

    // const urlSegments = url.split("/").filter(Boolean); // Remove empty segments
    // const uniqueSegments = [...new Set(urlSegments)]; // Remove duplicates

    // const cleanedPath = "/" + uniqueSegments.join("/");
    // console.log("Cleaned URL2:", cleanedPath);
    // console.log("Cleaned URL:", cleanedUrl);
    return cleanedUrl;
  };

  return (
    // <TabContext  value={value}>
    <Grid flexDirection={"column"} display={"flex"}>
      <Versions
      versionOpenState={versionsOpenState}
      setVersionOpenState={setVersionOpenState}
      versionLists={productItemList[0]?.Versions}
      downloadHandler={downloadSpecificExtensionsHandler}
      />
      <InstallationGuide 
      guideOpenState={guideOpenState}
      setGuideOpenState={setGuideOpenState}
      URL={productItemList[0]?.InstallationGuideLink}
      />
      <SupportForm
      supportFor={"contactUs"}
      openState={formOpenState}
      setFormOpenState={setFormOpenState}
      />
      <FeatureRequestForm
      featureRequestFor={"Feature Request"}
      requestFormOpenState={requestFormOpenState}
      setRequestFormOpenState={setRequestFormOpenState}
      />
      <TabContext value={innerTabValue || productItemList[0]?.ReferenceName || ""}>
      <Box>
        <Grid
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        mt={3}
        mb={2}
        mr={2}
        ml={0}
        >
        <Grid
          item
          sx={{ maxWidth: { xs: 420, sm: 580 } }}
        >
          <Tabs
          value={innerTabValue || productItemList[0]?.ReferenceName || ""}
          onChange={handleChange}
          variant="scrollable"
          aria-label="visible arrows tabs example"
          sx={{
            minHeight: "30px",
            ml: 0,
            "& button.Mui-disabled": {
            color: "#dfdfdf",
            cursor: "no-drop",
            },
            "& button.Mui-selected": {},
          }}
          TabIndicatorProps={{ sx: { backgroundColor: "#F9F9F9" } }}
          >
          {productItemList.map((item: any, index: number) => (
            <Tab
            sx={{
              p: 0,
              px: 2,
              mr: 1,
              minHeight: "30px",
              border: 0,
              bgcolor: "#F9F9F9",
              fontSize: "15px",
              fontWeight: 400,
            }}
            disabled={!item.IsAvailable}
            label={item.Name}
            value={item.ReferenceName}
            icon={
              <Button
              aria-label="Beta Version"
              sx={{
                display: item.IsBeta ? "" : "none",
                color: "#F47907",
                cursor: "default",
                bgcolor: "#FFF2CD",
                height: "15px",
                minWidth: "38px",
                fontSize: "9px",
                fontWeight: "400",
                borderRadius: "10px",

                ":hover": {
                bgcolor: "#FFF2CD",
                },
              }}
              >
              Beta
              </Button>
            }
            iconPosition="end"
            key={index}
            />
          ))}
          </Tabs>
        </Grid>

        <Grid>
          <Typography component={"span"}>
          {!productItemList[0]?.IsAutoSetup ||
          productItemList[0]?.SupportedPlan > planLevel ? (
            <Button
            disabled={!productItemList[0]?.IsAvailable}
            onClick={() =>
              contactHandler({
              supportFor: productItemList[0]?.ReferenceName,
              })
            }
            variant="contained"
            sx={{
              width: "160px",
              bgcolor: "#3A3A3A",
              fontSize: "11px",
              "&:hover": {
              bgcolor: "#3a3a3ae3",
              },
            }}
            >
            Contact us
            </Button>
          ) : (
            <Box>
            <LoadingButton
              onClick={downloadExtensionsHandler}
              disabled={
              !authCxt.userInfo?.isVarified ||
              !productItemList[0]?.IsAvailable
              }
              variant="contained"
              sx={{
              width: "130px",
              bgcolor: "#3A3A3A",
              fontSize: "11px",
              "&:hover": {
                bgcolor: "#3a3a3ae3",
              },
              }}
            >
              Download
            </LoadingButton>
            <LoadingButton
              onClick={() => guideHandler(productItemList[0]?.InstallationGuideLink || "")}
              disabled={
              !productItemList[0]?.InstallationGuideLink
              }
              variant="outlined"
              sx={{
              ml: 3,
              width: "130px",
              fontSize: "11px",
              border: "1px solid #3A3A3A",
              color: "#3A3A3A",
              "&:hover": {
                border: "1px solid #3A3A3A",
              },
              }}
            >
              Installation video
            </LoadingButton>
            </Box>
          )}
          </Typography>
        </Grid>
        </Grid>
      </Box>
      <Box>
        {productItemList.map((item: any, index: number) => (
        <TabPanel
          key={index}
          value={item.ReferenceName}
          sx={{ m: "0px", p: "0px" }}
        >
          <Grid container display={"flex"} flexDirection={"column"}>
          <Grid>
            <Typography variant={"body1"} p={2}>
            {item.Description}
            </Typography>
            <Typography sx={{ padding: "0 10px" }}>
            <img
              src={`/assets/Images/${item.ReferenceName}/${item.Image}`}
              width={"100%"}
            />
            </Typography>
          </Grid>

          <Grid
            container
            display={"flex"}
            justifyContent={"space-between"}
            alignContent="center"
          >
            <Grid item py={1} pr={3} pl={1} xs={9} md={9}>
            <Box
              sx={{ boxShadow: 2, borderRadius: "4px" }}
              bgcolor={"#fff"}
            >
              <CarouselSlider
              features={item.Features}
              solutionRef={item.ReferenceName}
              />
            </Box>
            </Grid>
            <Grid item xs={3} md={3} pt={3} pr={3} pb={2}>
            <Grid
              container
              spacing={2}
              display={"flex"}
              flexDirection={"column"}
              bgcolor={"#EFEFEF"}
              p={2}
              pt={1}
            >
              <Grid item>
              <Typography color={"#3A3A3A"} variant="subtitle1">
                Quick Links
              </Typography>
              </Grid>

              <Grid item>
              <Button
                variant="contained"
                sx={{
                height: "38px",
                width: "100%",
                bgcolor: "#FFFFFF",
                color: "#3A3A3A",
                boxShadow: 0,
                textAlign: "left",
                "&:hover": {
                  bgcolor: "rgba(0, 0, 0, 0.04)",
                },
                }}
                focusRipple={false}
                disableRipple
              >
                <Grid
                sx={{ width: "100%" }}
                display={"flex"}
                justifyContent={"space-between"}
                alignContent={"center"}
                alignItems={"center"}
                onClick={() =>
                  versionHandler({
                  versionRequestFor:
                    productItemList[0]?.ReferenceName,
                  })
                }
                >
                <Grid item>
                  <Typography variant="subtitle2">
                  Versions
                  </Typography>
                </Grid>
                <Grid item sx={{ pt: "4px" }}>
                  <ChevronRightIcon />
                </Grid>
                </Grid>
              </Button>
              </Grid>

              <Grid item>
              <Link
                to={cleanURL(
                `${item.HelpLink}/${downloadProduct}/${productCategoryRef}/${item.ReferenceName}`
                )}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                variant="contained"
                sx={{
                  height: "38px",
                  width: "100%",
                  bgcolor: "#FFFFFF",
                  color: "#3A3A3A",
                  boxShadow: 0,
                  textAlign: "left",
                  "&:hover": {
                  bgcolor: "rgba(0, 0, 0, 0.04)",
                  },
                }}
                focusRipple={false}
                disableRipple
                >
                <Grid
                  sx={{ width: "100%" }}
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignContent={"center"}
                  alignItems={"center"}
                >
                  <Grid item>
                  <Typography variant="subtitle2">
                    Documentation
                  </Typography>
                  </Grid>
                  <Grid item sx={{ pt: "4px" }}>
                  <ChevronRightIcon />
                  </Grid>
                </Grid>
                </Button>
              </Link>
              </Grid>

              <Grid item>
              <Link
                to={"https://releases.senseops.com/"}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                variant="contained"
                sx={{
                  height: "38px",
                  width: "100%",
                  bgcolor: "#FFFFFF",
                  color: "#3A3A3A",
                  boxShadow: 0,
                  textAlign: "left",
                  "&:hover": {
                  bgcolor: "rgba(0, 0, 0, 0.04)",
                  },
                  "&.Mui-disabled": {
                  color: "#dfdfdf",
                  bgcolor: "rgba(0, 0, 0, 0.04)",
                  },
                }}
                focusRipple={false}
                disableRipple
                >
                <Grid
                  sx={{ width: "100%" }}
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignContent={"center"}
                  alignItems={"center"}
                >
                  <Grid item>
                  <Typography variant="subtitle2">
                    Release Notes
                  </Typography>
                  </Grid>
                  <Grid item sx={{ pt: "4px" }}>
                  <ChevronRightIcon />
                  </Grid>
                </Grid>
                </Button>
              </Link>
              </Grid>

              <Grid item>
              <Button
                variant="contained"
                sx={{
                height: "38px",
                width: "100%",
                bgcolor: "#FFFFFF",
                color: "#3A3A3A",
                boxShadow: 0,
                textAlign: "left",
                "&:hover": {
                  bgcolor: "rgba(0, 0, 0, 0.04)",
                },
                }}
                focusRipple={false}
                disableRipple
              >
                <Grid
                sx={{ width: "100%" }}
                onClick={() =>
                  requestFormHandler({
                  featureRequestFor:
                    productItemList[0]?.ReferenceName,
                  })
                }
                display={"flex"}
                justifyContent={"space-between"}
                alignContent={"center"}
                alignItems={"center"}
                >
                <Grid item>
                  <Typography variant="subtitle2">
                  Request Feature
                  </Typography>
                </Grid>
                <Grid item sx={{ pt: "4px" }}>
                  <ChevronRightIcon />
                </Grid>
                </Grid>
              </Button>
              </Grid>
            </Grid>
            </Grid>
          </Grid>
          </Grid>
        </TabPanel>
        ))}
      </Box>
      </TabContext>
    </Grid>
    // </TabContext>
  );
};

export default InnerTabs;
